import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

const tubeHeight = em(300)
const tubeHeightMd = em(520)

export const TubeWrapper = styled.div`
  position: relative;
  height: ${tubeHeight};

  ${p => p.theme.mq.upMd} {
    height: ${tubeHeightMd};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: absolute;
  top: 5%;
  left: 50%;
  width: ${em(280)};
  height: auto;
  transform: translateX(-60%);

  ${p => p.theme.mq.upMd} {
    width: 100%;
    left: 0;
    min-width: ${em(390)};
    max-width: ${em(540)};
    transform: none;
  }

  ${p => p.theme.mq.upLg} {
    top: -10%;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }
`
